import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";

const el = document.getElementById("root");
if (!el) {
  throw new Error('Missing <div id="root"></div> in public/index.html');
}

const root = createRoot(el);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
